import React, { useState } from "react";
import Images from "../../commonComponents/Images/Images";
import { Link } from "react-router-dom";
import BookADemoModal from "./BookADemoModal";
import axios from "axios";

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [demoModalShow, setDemoModalShow] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobile_no: "",
    country_code: "+91",
    message: "",
  });

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const contactFormUrl = `${apiUrl}/user-registration`;

  /* -------------------- HANDLE CHANGE -------------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_no" && !/^\d{0,10}$/.test(value)) return;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  /* -------------------- VALIDATION -------------------- */
  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!formData.full_name.trim()) {
      newErrors.full_name = "Full name is required.";
      valid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
      valid = false;
    }

    if (formData.mobile_no && formData.mobile_no.length !== 10) {
      newErrors.mobile_no = "Please enter a valid 10-digit mobile number.";
      valid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  /* -------------------- SUBMIT -------------------- */
  const submitContactForm = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      country_code: formData.country_code,
      mobile_no: formData.mobile_no,
      full_name: formData.full_name,
      email: formData.email,
      message: formData.message,
    };

    try {
      const res = await axios.post(contactFormUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      });

      if (res.status === 200 || res.data?.status === 1) {
        setSubmitted(true);
        setHasError(false);
        setFormData({
          full_name: "",
          email: "",
          mobile_no: "",
          country_code: "+91",
          message: "",
        });
      } else {
        setHasError(true);
      }
    } catch (error) {
      console.error("Registration failed:", error);
      setHasError(true);
      setSubmitted(false);
    }
  };

  /* -------------------- UI -------------------- */
  return (
    <>
      <section className="contact-form-section">
        <div className="container p-5">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
              <img
                src={Images.contactUsFormImg}
                alt="Contact Us"
                className="img-fluid"
              />
            </div>

            {/* FORM */}
            {!submitted && !hasError && (
              <div className="col-lg-6 col-md-12">
                <form className="contactUs-form" onSubmit={submitContactForm} >

                  <div className="mb-2">
                    <label>Full Name<span>*</span></label>
                    <input
                      type="text"
                      className="form-control bg-ash"
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleChange}
                      placeholder="Enter Full Name"
                    />
                    {errors.full_name && (
                      <p className="error-message">{errors.full_name}</p>
                    )}
                  </div>

                  <div className="mb-2">
                    <label>Email<span>*</span></label>
                    <input
                      type="email"
                      className="form-control bg-ash"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter a valid email"
                    />
                    {errors.email && (
                      <p className="error-message">{errors.email}</p>
                    )}
                  </div>

                  <div className="mb-2">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      className="form-control bg-ash"
                      name="mobile_no"
                      value={formData.mobile_no}
                      onChange={handleChange}
                      placeholder="Enter phone number"
                    />
                    {errors.mobile_no && (
                      <p className="error-message">{errors.mobile_no}</p>
                    )}
                  </div>

                  <div className="mb-2">
                    <label>Message<span>*</span></label>
                    <textarea
                      className="form-control bg-ash"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Provide details or feedback"
                    />
                    {errors.message && (
                      <p className="error-message">{errors.message}</p>
                    )}
                  </div>

                  <button
                    className="btn btn-yellow text-light mt-3 w-100"
                    type="submit"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            )}

            {/* SUCCESS */}
            {submitted && !hasError && (
              <div className="col-lg-6 col-md-12 text-center">
                <img src={Images.successImg} alt="Success" width="120" />
                <h5 className="mt-3">Thank you for reaching out!</h5>
                <p>
                  We’ve received your message and our team will get back to you shortly.
                </p>

              
              </div>
            )}

            {/* ERROR */}
            {hasError && (
              <div className="col-lg-6 col-md-12 text-center">
                {/* <img src={Images.errorImg} alt="Error" width="120" /> */}
                <h5 className="mt-3 text-danger">Oops! Something went wrong.</h5>
                <p>
                  We couldn’t submit your message. Please try again or contact us at{" "}
                  <a href="mailto:support@digidoc.co.in">
                    support@digidoc.co.in
                  </a>
                </p>

                <button
                  className="btn btn-outline-primary mt-3"
                  onClick={() => {
                    setHasError(false);
                    setSubmitted(false);
                  }}
                >
                  Try Again
                </button>
              </div>
            )}

          </div>
        </div>
      </section>

      <BookADemoModal
        show={demoModalShow}
        onHide={() => setDemoModalShow(false)}
      />
    </>
  );
};

export default ContactForm;
